var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tx-quick-board",
      class: { "betting-closed": !_vm.isBetOpen },
    },
    [
      _c("div", { staticClass: "tx-quick-board__main" }, [
        _c(
          "button",
          {
            staticClass: "tx-quick-board__side tx-quick-board__side--tai",
            class: _vm.cellClass("tai"),
            attrs: {
              type: "button",
              disabled: !_vm.isBetOpen || _vm.isSelectionBlocked("tai"),
            },
            on: {
              click: function ($event) {
                return _vm.onBet("tai")
              },
            },
          },
          [
            _c("span", { staticClass: "tx-quick-board__title" }, [
              _vm._v("TÀI"),
            ]),
            _vm._m(0),
            _vm.displayBets.tai
              ? _c("BetPlacedChip", {
                  attrs: {
                    amount: _vm.displayBets.tai,
                    chips: _vm.chips,
                    placement: "top-left",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "tx-quick-board__odd-even" },
          _vm._l(_vm.oddEven, function (side) {
            return _c(
              "button",
              {
                key: side.key,
                staticClass: "tx-quick-board__parity",
                class: _vm.cellClass(side.key),
                attrs: {
                  type: "button",
                  disabled: !_vm.isBetOpen || _vm.isSelectionBlocked(side.key),
                },
                on: {
                  click: function ($event) {
                    return _vm.onBet(side.key)
                  },
                },
              },
              [
                _c("span", { staticClass: "tx-quick-board__parity-title" }, [
                  _vm._v(_vm._s(side.title)),
                ]),
                _c("span", { staticClass: "tx-quick-board__parity-sub" }, [
                  _vm._v(_vm._s(side.sub)),
                ]),
                _vm.displayBets[side.key]
                  ? _c("BetPlacedChip", {
                      attrs: {
                        amount: _vm.displayBets[side.key],
                        chips: _vm.chips,
                        placement: "top-right",
                        overlap: "",
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        ),
        _c(
          "button",
          {
            staticClass: "tx-quick-board__side tx-quick-board__side--xiu",
            class: _vm.cellClass("xiu"),
            attrs: {
              type: "button",
              disabled: !_vm.isBetOpen || _vm.isSelectionBlocked("xiu"),
            },
            on: {
              click: function ($event) {
                return _vm.onBet("xiu")
              },
            },
          },
          [
            _c("span", { staticClass: "tx-quick-board__title" }, [
              _vm._v("XỈU"),
            ]),
            _vm._m(1),
            _vm.displayBets.xiu
              ? _c("BetPlacedChip", {
                  attrs: {
                    amount: _vm.displayBets.xiu,
                    chips: _vm.chips,
                    placement: "top-right",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "tx-quick-board__sums" },
        _vm._l(_vm.sums, function (sum) {
          return _c(
            "button",
            {
              key: sum,
              staticClass: "tx-quick-board__sum",
              class: _vm.cellClass(`sum-${sum}`),
              attrs: {
                type: "button",
                disabled: !_vm.isBetOpen,
                title: _vm.totalOdds(sum),
              },
              on: {
                click: function ($event) {
                  return _vm.onBet(`sum-${sum}`)
                },
              },
            },
            [
              _vm._v(" " + _vm._s(sum) + " "),
              _vm.displayBets[`sum-${sum}`]
                ? _c("BetPlacedChip", {
                    staticClass: "tx-quick-board__mini-chip",
                    attrs: {
                      amount: _vm.displayBets[`sum-${sum}`],
                      chips: _vm.chips,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "tx-quick-board__singles" },
        _vm._l(_vm.dieFaces, function (face) {
          return _c(
            "button",
            {
              key: face,
              staticClass: "tx-quick-board__single",
              class: _vm.cellClass(`single-${face}`),
              attrs: { type: "button", disabled: !_vm.isBetOpen },
              on: {
                click: function ($event) {
                  return _vm.onBet(`single-${face}`)
                },
              },
            },
            [
              _c("img", {
                attrs: { src: _vm.diceImage(face), alt: `Single ${face}` },
              }),
              _vm.displayBets[`single-${face}`]
                ? _c("BetPlacedChip", {
                    staticClass: "tx-quick-board__mini-chip",
                    attrs: {
                      amount: _vm.displayBets[`single-${face}`],
                      chips: _vm.chips,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _c("div", { staticClass: "tx-quick-board__footer" }, [
        _c(
          "button",
          {
            staticClass: "tx-quick-board__undo",
            attrs: {
              type: "button",
              "aria-label": _vm.$t("Undo"),
              disabled: !_vm.canUndo,
            },
            on: {
              mousedown: _vm.onUndoPressStart,
              mouseup: _vm.onUndoPressEnd,
              mouseleave: _vm.onUndoPressCancel,
            },
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/svg/btns/undo.svg"), alt: "" },
            }),
            _c("small", [_vm._v(_vm._s(_vm.$t("Undo")))]),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "tx-quick-board__arrow",
            attrs: {
              type: "button",
              "aria-label": _vm.$t("Previous chip"),
              disabled: _vm.cycleChips.length < 2,
            },
            on: {
              click: function ($event) {
                return _vm.stepChip(-1)
              },
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/svg/tx-quickplay/chevron.svg"),
                alt: "",
              },
            }),
          ]
        ),
        _c("span", { staticClass: "tx-quick-board__chip" }, [
          _c("img", { attrs: { src: _vm.activeChipImage, alt: "" } }),
          _c("span", { class: _vm.chipValueClass }, [
            _vm._v(_vm._s(_vm.activeChipLabel)),
          ]),
        ]),
        _c(
          "button",
          {
            staticClass: "tx-quick-board__arrow tx-quick-board__arrow--next",
            attrs: {
              type: "button",
              "aria-label": _vm.$t("Next chip"),
              disabled: _vm.cycleChips.length < 2,
            },
            on: {
              click: function ($event) {
                return _vm.stepChip(1)
              },
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/svg/tx-quickplay/chevron.svg"),
                alt: "",
              },
            }),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "tx-quick-board__submit",
            attrs: {
              type: "button",
              disabled:
                _vm.isSubmitting ||
                _vm.isRolling ||
                !_vm.isBetOpen ||
                !_vm.hasBets,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("submit")
              },
            },
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.isRolling ? _vm.$t("Rolling") : _vm.$t("Bet")) +
                " "
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "tx-quick-board__sub" }, [
      _vm._v("BIG"),
      _c("i"),
      _vm._v("11-17"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "tx-quick-board__sub" }, [
      _vm._v("SMALL"),
      _c("i"),
      _vm._v("4-10"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }